/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Coinvestments_Performancereport_Irrnet3Inputs */

const en_coinvestments_performancereport_irrnet3 = /** @type {(inputs: Coinvestments_Performancereport_Irrnet3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`IRR: ${i?.value} (net)`)
};

/**
* | output |
* | --- |
* | "IRR: {value} (net)" |
*
* @param {Coinvestments_Performancereport_Irrnet3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_performancereport_irrnet3 = /** @type {((inputs: Coinvestments_Performancereport_Irrnet3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Performancereport_Irrnet3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_performancereport_irrnet3(inputs)
});
export { coinvestments_performancereport_irrnet3 as "coInvestments_performanceReport_irrNet" }